import React from 'react';
import styled from 'styled-components';
import { IconButton, withStyles } from '@material-ui/core';
import { InsertComment } from '@material-ui/icons';
import { white, red, green } from '@avangard/ui/colors';

import { useCurrentUser } from '@modules/auth/hooks';
import { useChats } from '@modules/chat/hooks';
import { ChatsDrawer } from '@modules/chat/organisms';
import { ChatType } from '@modules/types/graphql';

const insertCommentIcon = <InsertComment style={{ fontSize: 24 }} />;

const ChatsWidgets = () => {
    const { currentUser } = useCurrentUser();

    const [openChatsDrawer, setOpenChatsDrawer] = React.useState(false);

    const handleOpenChatsDrawer = () => setOpenChatsDrawer(true);
    const handleCloseChatsDrawer = () => setOpenChatsDrawer(false);

    const { chats, count: chatsCount } = useChats({
        skip: !currentUser.authenticated(),
        variables: { type: ChatType.soa },
        pollInterval: 15_000,
    });

    if (chatsCount === 0 || chatsCount > 1) {
        return null;
    }

    // Пока не добавили фильтрацию по чатам - считаем что всегда один чат
    const newMessages = chats[0].getNewMessagesCount();

    return (
        <Root>
            <StyledIconButton disableRipple onClick={handleOpenChatsDrawer}>
                {insertCommentIcon}

                {newMessages > 0 ? <NewMessagesCounter>{newMessages}</NewMessagesCounter> : null}
            </StyledIconButton>

            <ChatsDrawer open={openChatsDrawer} chats={chats} onClose={handleCloseChatsDrawer} />
        </Root>
    );
};

const StyledIconButton = withStyles(() => ({
    root: {
        padding: 14,
        background: red[100],
        boxShadow: '0 5px 8px rgba(0, 0, 0, .2)',
        transition: 'all .2s',

        '&:hover': {
            background: red[100],
            boxShadow: '0 5px 8px rgba(0, 0, 0, .1)',
        },
    },

    label: {
        color: white[100],
    },
}))(IconButton);

const Root = styled.div`
    position: fixed;
    right: 52px;
    bottom: 40px;
    z-index: 50;
`;

const NewMessagesCounter = styled.span`
    position: absolute;
    top: -5px;
    right: -5px;

    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    width: 20px;
    height: 20px;

    color: ${white[100]};
    font-size: 1.2rem;
    font-weight: 500;

    background-color: ${green[100]};
    border-radius: 50%;
`;

export { ChatsWidgets };
